import { isStorable } from '@amplify/amp-module';

export default class NodeHandlerBase {
  constructor(ctx, nodeType) {
    const { store } = ctx;
    this.store = store;
    this.nodeType = nodeType;
  }

  // eslint-disable-next-line class-methods-use-this , no-unused-vars
  addToStorage(node) {
    // eslint-disable-next-line no-console
    console.error('Method not implemented.');
  }

  // eslint-disable-next-line consistent-return
  async handleNode(node, options = {}) {
    const { handleStorage = true, addToStack = true } = options;
    if (!node.parentId) {
      const { name = 'New conversation' } = this.store.getters['chatbotStore/currentConversation'] || {};
      node = { ...node, conversationName: name };
    }

    if (addToStack) {
      this.store.dispatch('chatbotStore/addNode', node);
    }

    if (isStorable(node) && handleStorage) {
      this.addToStorage(node);
    }

    try {
      if (node.delay) {
        await new Promise((resolve, reject) => {
          const delayTimer = setTimeout(() => {
            this.store.dispatch('chatbotStore/setDelayedState', {
              nodeId: node.id,
              delayed: false,
            });
            resolve();
          }, node.delay * 1000);
          this.store.dispatch('chatbotStore/saveDelay', { nodeId: node.id, delayTimer, reject });
        });
      }

      const nextNode = this.store.getters['chatbotStore/nextNode'](node.id);

      return nextNode;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error ', err);
    }
  }
}
